import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { AsyncPaginate } from "react-select-async-paginate";
import moment from "moment";
import { ForeignData_API } from "../../../APIs/ForeignData.api";
import RenderInputs from "../../../Components/Inputs";
import submitForm from "../../../services/submitForm";
import { error } from "jquery";
import RenderInputsLDB from "./RenderInputsLDB";

export default function CreateLenhDongBao() {
  const {
    lang,
    pages,
    proxy,
    functions,
    database: { fields, tables },
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    getValues,
    reset,
    control,
    formState: { errors },
  } = useForm();
  const [isSubmit, setSubmit] = useState(false);
  const [defaultValues, setDefaultValues] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [isTables, setTables] = useState([]);
  const [options, setOptions] = useState({});
  const [refresh, setRefresh] = useState(0);
  const [isDisabled, setDisabled] = useState({
    "2SCSX": true,
  });
  const [isChecked, setIsChecked] = useState({
    "2SCSX": false,
  });

  const [inputFields, setInputFields] = useState([
    {
      name: "Mã Lệnh Đóng Bao",
      alias: "1MLĐB",
      type: "text",
      required: true,
      readOnly: true,
    },
    {
      name: "Mã Lệnh Sản Xuất",
      alias: "lenhSanXuatLDB",
      type: "select",
      required: true,
      table_id: 3986052,
      displayFields: ["lenhSanXuatLSX"],
      isPK: "lenhSanXuatLSX",
      isBased: {
        name: "2SCSX",
        alias: "soLuongCanSanXuatLSX",
      },
    },
    {
      name: "Mã Thành Phẩm",
      alias: "23MSP",
      table_id: "21692",
      type: "select",
      required: true,
      displayFields: ["22MSP", "10TSP"],
      isApi: "/api/LDB/optionSPLDB",
      isParent: {
        alias: "lenhSanXuatLDB",
      },
      isPK: "22MSP",
    },
    {
      name: "Số Lượng Sản Xuất (bao)",
      alias: "2SCSX",
      type: "float",
      isCheckbox: true,
    },
    {
      name: "Số LOT",
      alias: "7SL",
      type: "text",
      required: true,
      // col: "col-md-6 offset-md-3",
      child: [
        {
          name: "Grade Code",
          alias: "maKyHieu",
          type: "input-select",
          table_id: 3663535,
          displayFields: ["maKyHieuLOT"],
          style: {
            borderRadius: "0 .25rem 0 0",
            borderLeft: "0px",
          },
          isPK: "maKyHieuLOT",
        },
      ],
    },
    // {
    //   name: "Số Lượng Sản Xuất Dư",
    //   alias: "1SLSXD",
    //   type: "number",
    // },
    // {
    //   name: "Thời Gian Bắt Đầu",
    //   alias: "11NSX",
    //   type: "datetime-local",
    //   required: true,
    //   col: "col-md-3 offset-md-3",
    // },
    // {
    //   name: "Thời Gian Kết Thúc",
    //   alias: "thoiGianKetThucLDB",
    //   type: "datetime-local",
    //   col: "col-md-3",
    //   required: true,
    // },
    // {
    //   name: "Số LOT",
    //   alias: "7SL",
    //   type: "text",
    //   required: true,
    //   col: "col-sm-7 offset-sm-3 p-0",
    //   // col: "null",
    // },
    // {
    //   name: "Mã Ký Hiệu",
    //   alias: "maKyHieu",
    //   type: "input-select",
    //   required: true,
    //   table_id: "3663535",
    //   displayFields: ["maKyHieuLOT"],
    //   col: "col-sm-2",
    //   style: {
    //     position: "absolute",
    //     top: "52.2%",
    //     right: "24.4%",
    //     // width: "10%"
    //   },
    //   // col: "null",
    // },
    // {
    //   name: "Mã tổ chức kho",
    //   alias: "maToChucKho",
    //   type: "select",
    //   required: true,
    //   displayFields: ["2MLK", "7LK"],
    //   table_id: "21715",
    // },
    // {
    //   name: "Kho Nhập",
    //   alias: "makhoNhap",
    //   type: "select",
    //   required: true,
    //   displayFields: ["11MK", "4TK"],
    //   table_id: "21719",
    // },
    {
      name: "Ghi Chú",
      alias: "1GCS",
      type: "textarea",
    },
  ]);
  const _token = localStorage.getItem("_token");
  const [watchNSX, watchLotId, watchMaKyHieu, watchLenhSanXuatLDB] = watch([
    "thoiGianBatDauLSX",
    "7SL",
    "maKyHieu",
    "lenhSanXuatLDB",
  ]);

  useEffect(() => {
    if (watchLenhSanXuatLDB) {
      setDisabled((prev) => ({
        ...prev,
        "23MSP": true,
      }));
      setValue("23MSP", "");
      setSelectedValues((prev) => ({
        ...prev,
        "23MSP": null,
      }));
      setValue("7SL", "");
      return;
    }
  }, [watchLenhSanXuatLDB]);

  useEffect(() => {
    const product = selectedValues?.["23MSP"];

    if (!product?.value) {
      setValue("7SL", null);
      setValue("maKyHieu", null);
      return;
    }

    const solot = getValues("7SL")?.replace(/\.RF$/, "");
    const baseLot = solot || moment(product.NSX).format("YYYY.MM");

    setValue("7SL", `${baseLot}.RF`);
    setValue("maKyHieu", product.defaultgrade);
  }, [selectedValues]);

  useEffect(() => {
    const lot = getValues("7SL");

    if (!lot) {
      setValue("7SL", "");
      setValue("maKyHieu", "");
      return;
    }

    const baseLot = lot.split(".").slice(0, 3).join(".");
    const mkh = getValues("maKyHieu");
    const newLot = mkh ? `${baseLot}.${mkh}` : baseLot;

    setValue("7SL", newLot);
  }, [watchMaKyHieu]);

  if (watchNSX) {
    // const lastDayOfMonth = moment(watchNSX)
    //   .endOf("month")
    //   .format("yyyy-MM-DDTHH:mm");
    // const lotId = moment(watchNSX).format("YYYY.MM.").replace(/\//g, "");
    // setValue("7SL", lotId + watchMaKyHieu);
    // setValue("thoiGianKetThucLDB", lastDayOfMonth);
  }

  useEffect(() => {
    fetch(proxy() + "/api/LDB", {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { success, data } = res;
        if (success) {
          const firstDayOfMonth = moment(watchNSX)
            .startOf("month")
            .format("yyyy-MM-DDTHH:mm");
          // setValue("11NSX", firstDayOfMonth);
          setValue("1MLĐB", data);
          // setValue("2SCSX", 1);
        }
      });
  }, [refresh]);

  useEffect(() => {
    const tableId = 22587;
    const api_id = [];

    pages
      .filter(({ is_hidden }) => !is_hidden)
      .forEach((page) => {
        page.children
          .filter(({ is_hidden }) => !is_hidden)
          .forEach((child) => {
            child.component.forEach((item) => {
              const { props } = item;
              const findId = props.source?.tables?.find(
                (item) => item.id === tableId,
              );
              if (findId) {
                const currentPage = pages.find((p) => p.block === item.id)
                  ?.component?.[0]?.children;

                if (currentPage) {
                  const mappedFields = currentPage
                    .map((item) => {
                      const {
                        props: {
                          variable_name,
                          title: { content, visible },
                          required,
                          displayField,
                          betChar,
                          textarea,
                        },
                      } = item;
                      if (!visible) return null;

                      const field = inputFields.find(
                        ({ alias }) => alias === variable_name,
                      );

                      if (field) {
                        return {
                          ...field,
                          name: content,
                          alias: variable_name,
                          type: textarea ? "textarea" : field.type,
                          required,
                          betChar,
                          displayFields:
                            displayField && displayField.length
                              ? displayField?.map(({ value }) => value)
                              : field.displayFields,
                        };
                      }
                    })
                    .filter(Boolean);
                  setInputFields(mappedFields);
                }
                setTables(findId);
                api_id.push(props?.buttons?.add?.api?.api_id);
              }
            });
          });
      });

    fetch(`${proxy()}/apis/api/${api_id?.[0]}/input_info`, {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { data } = res;
        if (data) {
          setDefaultValues(data?.display_fields);
          data?.display_fields.forEach((item) => {
            if (inputFields.some(({ alias }) => item.fomular_alias === alias)) {
              const { default_value, fomular_alias } = item;
              if (default_value) {
                // setValue(fomular_alias, item.default_value);
              }
            }
          });
        }
      });
  }, [pages]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const selectedValuesTemp = {};

        inputFields.forEach(async ({ type, child }) => {
          const item =
            type === "input-select" ||
            (child && child.find(({ type }) => type === "input-select"));

          if (item) {
            const table_id = item?.table_id;
            const foreignResponse = await ForeignData_API.get(proxy(), _token, {
              table_id,
            });
            const { data: foreignData = [] } = foreignResponse;
            if (foreignData.length) {
              const mapped = foreignData.reduce((acc, curr) => {
                const fields = item?.displayFields?.map((field) => curr[field]);
                if (fields.some((field) => field)) {
                  acc.push({
                    label: fields.join("|"),
                    value: fields?.[0],
                  });
                }
                return acc;
              }, []);
              setOptions(mapped);
            }
          }
        });

        // setOptions((prev) => ({ ...prev, ...selectedValuesTemp }));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [inputFields, _token]);

  const onSubmit = async (data) => {
    const trimmedData = Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        typeof value === "string" ? value.trim() : value,
      ]),
    );
    const mappedData = {
      data: trimmedData,
      default_field_value: defaultValues,
      table: isTables,
    };

    const res = await submitForm({
      url: `/api/LDB`,
      data: mappedData,
      proxy,
      lang,
      inputFields,
    });

    if (res) {
      inputFields.forEach((item) => {
        const { alias, readOnly } = item;
        if (!readOnly) {
          reset({
            [alias]: "",
          });
        }
      });
      setRefresh(refresh + 1);
      setSelectedValues({});
    }
  };

  return (
    <>
      <form className="midd_cont" onSubmit={handleSubmit(onSubmit)}>
        <div className="container-fluid">
          <div className="row column_title">
            <div className="col-md-12">
              <div className="page_title">
                <h4 className="ml-1">Quản Lý Dữ Liệu</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="white_shd full margin_bottom_30 mb-0">
                <div className="full graph_head_cus d-flex">
                  <div className="heading1_cus margin_0 ">
                    <h5>
                      <label className="pointer" onClick={() => navigate(-1)}>
                        <a title={lang["back"]}>
                          <i className=" fa fa-chevron-circle-left mr-1 mt-3 mb-0 nav-item nav-link" />
                        </a>
                        Lệnh Đóng Bao
                        <i className="fa fa-chevron-right ml-2 mr-1" />
                        {lang["create"]}
                      </label>
                    </h5>
                  </div>
                </div>
                <div className="table_section padding_infor_info input_put">
                  <div className="col-md-12">
                    <div
                      style={{
                        height: "70vh",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <div className="row w-50-pct mg-auto p-1 bg-white input-put">
                        {inputFields.map((field, index) => {
                          const {
                            required,
                            name,
                            alias,
                            type,
                            col,
                            readOnly = false,
                            table_id,
                            displayFields,
                            style,
                            child,
                            isCheckbox,
                          } = field;
                          return (
                            <>
                              <div
                                className={` ${
                                  col ? col : `col-sm-8  offset-sm-2`
                                } mb-3`}
                                style={style}
                              >
                                {isCheckbox && (
                                  <input
                                    className="form-check-input ml-0"
                                    type="checkbox"
                                    value=""
                                    defaultChecked={isChecked?.[alias] || false}
                                    checked={isChecked?.[alias] || false}
                                    onClick={(e) => {
                                      const { checked } = e.target;
                                      if (!checked) {
                                        const oldValue = getValues("2SCSX");
                                        setValue("2SCSX", oldValue || "");
                                      }
                                      setDisabled((prev) => ({
                                        ...prev,
                                        "2SCSX": !prev["2SCSX"],
                                      }));
                                      setIsChecked((prev) => ({
                                        ...prev,
                                        "2SCSX": !prev["2SCSX"],
                                      }));
                                    }}
                                    // id={alias}
                                  />
                                )}
                                <div {...register(alias)}>
                                  <label
                                    className={`${
                                      isCheckbox && `ml-4`
                                    } form-label`}
                                    for={alias}
                                  >
                                    {name}
                                    {required && (
                                      <span style={{ color: "red" }}>*</span>
                                    )}
                                  </label>
                                  <div
                                    className={
                                      child && child.length && `input-group`
                                    }
                                  >
                                    <RenderInputsLDB
                                      control={control}
                                      register={register}
                                      selectedValues={selectedValues}
                                      setSelectedValues={setSelectedValues}
                                      field={field}
                                      options={options}
                                      setValue={setValue}
                                      getValues={getValues}
                                      refresh={refresh}
                                      watch={watch}
                                      setDisabled={setDisabled}
                                      isDisabled={isDisabled}
                                      errors={errors}
                                    />

                                    {child &&
                                      child.map((item) => (
                                        // <div className="input-group-append">
                                        <RenderInputsLDB
                                          control={control}
                                          register={register}
                                          selectedValues={selectedValues}
                                          setSelectedValues={setSelectedValues}
                                          field={item}
                                          options={options}
                                          setValue={setValue}
                                          getValues={getValues}
                                          isChild={true}
                                          refresh={refresh}
                                          watch={watch}
                                          setDisabled={setDisabled}
                                          isDisabled={isDisabled}
                                          errors={errors}
                                        />
                                        // </div>
                                      ))}
                                  </div>
                                </div>
                                {alias === "7SL" && errors[alias] && (
                                  <span style={{ color: "red" }}>
                                    {errors[alias].message}
                                  </span>
                                )}
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </div>
                    <div className="col-sm-7 offset-sm-3 p-0">
                      <div className="d-flex justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-success mr-2"
                          style={{
                            minWidth: "105px",
                          }}
                          onClick={() => setSubmit(true)}
                        >
                          Thêm mới
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger"
                          style={{
                            minWidth: "105px",
                          }}
                          onClick={() => navigate(-1)}
                        >
                          Đóng
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
